import React, { useEffect } from "react";
import { Text, Button, VerificationCodeInput } from "components/common";

const VerificationCodeCheckScreen = ({
  loading,
  errorMessage,
  sendToRecipient,
  titleText,
  verificationCode,
  setVerificationCode = () => {},
  handleSubmit = () => {},
}) => {
  useEffect(() => {
    if (verificationCode.length === 5) {
      handleSubmit();
    }
  }, [verificationCode]);
  return (
    <>
      <Text title className="text-xl">{titleText}</Text>
      <div className="mt-2 mx-4 text-sm">Please enter the 5 digit code sent to <span className="text-green-primary">{sendToRecipient}</span>. It may take a few minutes to receive.</div>
      <VerificationCodeInput
        disabled={loading}
        style={{ marginTop: 25 }}
        fontSize={4}
        value={verificationCode}
        onChange={(code) => setVerificationCode(code)}
      />
      <div className="text-red-500 text-sm mt-2">{errorMessage}</div>
      <div>
        <Button
          type="button"
          className="mb-6 mt-5 text-xl btn-green px-16"
          disabled={loading}
          style={{
            backgroundColor: loading ? "gray" : "#26E3BA",
          }}
          onClick={() => handleSubmit()}
          paddingHorizontal={64}
        >
          Submit
        </Button>
      </div>
    </>
  );
};

export default VerificationCodeCheckScreen;